// Entry point for the build script in your package.json
import "@hotwired/turbo"
import { createCable, fetchTokenFromHTML } from "@anycable/web"
import { start } from "@anycable/turbo-stream"

const metaPrefixes = ["action-cable", "cable"]

const fetchMeta = (key) => {
  for (const prefix of metaPrefixes) {
    const element = document.head?.querySelector(`meta[name='${prefix}-${key}']`)
    if (element) return element.getAttribute("content")
  }
}

const absoluteWSUrl = (path) => {
  if (!path) return null
  if (/^wss?:\/\//.test(path)) return path

  const proto = window.location.protocol.replace("http", "ws")
  return `${proto}//${window.location.host}${path}`
}

const syncTransportFromMeta = (transport) => {
  const url = absoluteWSUrl(fetchMeta("url"))
  if (url) transport.setURL(url)
}

// Use extended Action Cable protocol to support reliable streams and presence
// See https://github.com/anycable/anycable-client
const cable = createCable({
  protocol: "actioncable-v1-ext-json",
  // createCable() reads the JWT cable URL once at boot. After Turbo login the
  // meta tag appears, but the transport still has the unauthenticated fallback.
  // Re-read meta right before every connect so lobby presence uses the JWT URL.
  transportConfigurator: async (transport) => {
    syncTransportFromMeta(transport)
  },
  tokenRefresher: fetchTokenFromHTML()
})

// Prevent frequent resubscriptions during morphing or navigation
start(cable, { delayedUnsubscribe: true, presence: true })

// delayedUnsubscribe can reuse an already-connected presence subscription.
// In that case `connect` fires synchronously before listeners are attached,
// so the player list stays empty until a full reload. Catch up if needed.
const PresenceSource = customElements.get("turbo-cable-presence-source")
if (PresenceSource) {
  const originalConnectedCallback = PresenceSource.prototype.connectedCallback

  PresenceSource.prototype.connectedCallback = async function (...args) {
    await originalConnectedCallback.apply(this, args)

    if (this.channel?.state === "connected" && !this.presenceInitialized) {
      this.setAttribute("connected", "")
      await this.initializePresence()
    }
  }
}

import "./controllers"
